export function getCardBinAndBrand(number) {
  const visaRegex = /^4[0-9]{12}(?:[0-9]{3})?$/;
  const mastercardRegex =
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/;
  const amexRegex = /^3[47][0-9]{13}$/;
  const discoverRegex = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
  const dinersRegex = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
  const jcbRegex = /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/;

  const cardNumber = number.replaceAll(" ", "");

  let brand;
  let bin = number.replaceAll(" ", "").substr(0, 6);

  if (visaRegex.test(cardNumber)) brand = "Visa";
  if (mastercardRegex.test(cardNumber)) brand = "Mastercard";
  if (amexRegex.test(cardNumber)) brand = "American Express";
  if (discoverRegex.test(cardNumber)) brand = "Discover";
  if (dinersRegex.test(cardNumber)) brand = "Diners Club";
  if (jcbRegex.test(cardNumber)) brand = "JCB";

  if (brand) {
    return {
      brand,
      bin,
    };
  }

  return "Unknown";
}
